import { Icons, Text } from '@agro-club/agroclub-shared'
import useFormatDate from 'hooks/useFormatDate'
import { DASH } from 'modules/constants'
import { ProfileType, User } from 'modules/domain/user/types'
import formatNumber from 'modules/utils/numbers/formatNumber'
import { useTranslation } from 'react-i18next'
import {
  BlockedUserIcon,
  CoordinatorVerifiedUserIcon,
  KeyEntityIcon,
  NotVerifiedUserIcon,
  SecurityVerifiedUserIcon,
  UserHasDealsIcon,
  VerifiedUserIcon,
} from 'views/components/TooltipIcons/TooltipIcons'
import { BlockedWrapper, Rating, WrapperIcons } from 'views/ui/VerifyUserStatus/styled'

type Props = {
  user: User
}

const VerifyUserStatus = ({ user }: Props) => {
  const formatDate = useFormatDate()
  const { t } = useTranslation(['user', 'common'])
  const isVerifyCoordinator = user.profile?.is_verified_by_coordinator
  const isVerifySecurity = user.profile?.is_verified_by_security
  const isHasShippedDeals = user.profile?.has_shipped_deals
  const isSignificant = user.profile?.is_significant
  const isVerified = user.profile?.is_verified
  const isActive = user.is_active
  const rating = user.rating

  const showNotVerified = !![ProfileType.seller, ProfileType.customer, ProfileType.manager].find(
    (t) => t == user.profile?.profile_type,
  )

  if (!isActive) {
    return (
      <BlockedWrapper>
        <BlockedUserIcon isVisible size="large" />
        <Text color="accentDestruct600"> {t('blocked')}</Text>
        <Text>{user.blocked_at ? formatDate(user.blocked_at) : DASH}, </Text>
        <Text>{user.blocked_reason ? t(`blocked_reasons.${user.blocked_reason}`) : t('common:noReason')} </Text>
      </BlockedWrapper>
    )
  }

  return (
    <WrapperIcons>
      <KeyEntityIcon isVisible={isSignificant} size="large" />
      <VerifiedUserIcon isVisible={isVerified} size="large" />
      <UserHasDealsIcon isVisible={isHasShippedDeals} size="large" />
      <CoordinatorVerifiedUserIcon isVisible={!isVerified && isVerifyCoordinator} size="large" />
      <SecurityVerifiedUserIcon isVisible={!isVerified && isVerifySecurity} size="large" />
      <NotVerifiedUserIcon isVisible={showNotVerified && !isVerifySecurity && !isVerifyCoordinator} size="large" />
      {rating > 0 && (
        <Rating>
          <Icons.IconStar />
          {formatNumber(rating, true, { fractionDigits: 1 })}
        </Rating>
      )}
    </WrapperIcons>
  )
}

export default VerifyUserStatus
